import { SubscriptionPlan, ProductsUniqueIds } from "../../../../../global/paywall/paywallInterfaces";
import { CustomerDetails } from "../../../../../global/paywall/useDetailsUpdate";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { SettingLinks } from "../premiumPaywallCheckout";

interface PaywallCheckoutMobileFinishProps {
    setShouldRedirect: (shouldRedirect: boolean) => void;
    selectedPlan: SubscriptionPlan | null;
    customerDetails: CustomerDetails | null;
    settingLinks: SettingLinks;
}

const PaywallCheckoutMobileFinish = (props: PaywallCheckoutMobileFinishProps) => {
    const { setShouldRedirect, selectedPlan, customerDetails, settingLinks } = props;
    const { firstName, lastName, email, phoneNumber } = customerDetails || {};
    const { terms, privacy, contact, myAccount } = settingLinks;
    const isMonthly = selectedPlan.productUniqueId === ProductsUniqueIds.MONTHLY_PASS;
    const planTitle = isMonthly ? "חבילה בחיוב חודשי מתחדש" : "חבילה בחיוב שנתי מתחדש";
    const planPrice = isMonthly ? "₪29.90 לחודש" : "₪299.90 לשנה";
    const handleEventShouldRedirect = () => {
        setShouldRedirect(true);
        const redirectEvent = new CustomEvent("redirectEvent");
        document.dispatchEvent(redirectEvent);
    };

    return (
        <div className="PaywallCheckoutFinish">
            <div className="success-logo"></div>
            <div className="title"> הרכישה הושלמה! </div>
            <div className="subtitle">
                מעכשיו תוכלו ליהנות מגישה חופשית לכל
                <br />
                תכני ידיעות+  ולמהדורה הדיגיטלית של
                           ידיעות אחרונות
                    </div>

            <div className="checkout-container">
                <div className="plan-info">
                    <div className="plan-title">{planTitle}</div>
                    <div className="plan-price-text">{planPrice}</div>
                </div>
                <div className="customer-info">
                    <div className="customer-title">פרטי המנוי</div>
                    <div className="inner-container">
                        <div className="customer-name">{firstName + " " + lastName}</div>
                        <div className="customer-email">{email}</div>
                        <div className="custome-phone">{phoneNumber}</div>
                    </div>
                    <div className="customer-myaccount-info">ניתן לצפות ולערוך את פרטי המנוי <HyperLinkBuilder className="underline" href={myAccount.url} linkTarget={myAccount.target}>באזור האישי</HyperLinkBuilder></div>
                </div>
            </div>

            <button className="continue-button" onClick={() => handleEventShouldRedirect()}>מעבר לידיעות+</button>
        </div>
    );
};

export default PaywallCheckoutMobileFinish;
